import React, { useState } from 'react';
import styled from 'styled-components';
import { Color, Grid } from '../../../app/StyleGuide';
import { AdvancePlanningSection } from '../models/advancePlanning';
import { VolumeSection } from './VolumeSection';

type OverviewAdvancePlanningSectionProps = {
  planningItems: AdvancePlanningSection[];
};

const ListItems = styled.div`
  padding: 0;
`;

const VolumeSectionWrapper = styled(VolumeSection)`
  border-bottom: 1px solid ${Color.Gray._10};

  &:last-child {
    border-bottom: none;
  }

  &:first-child > div:first-child {
    padding-top: 0;
  }

  &:last-child > div:first-child {
    padding-bottom: 0;

    & + ul {
      margin-top: ${Grid._5};
    }
  }
`;

export const OverviewAdvancePlanningSection = ({ planningItems }: OverviewAdvancePlanningSectionProps) => {
  const [showContents, setShowContents] = useState('');

  const toggleMaterials = (sectionId: string) => {
    if (showContents === sectionId) {
      setShowContents('');
    } else {
      setShowContents(sectionId);
    }
  };

  return planningItems.length === 0 ? (
    <p>No advance planning items available</p>
  ) : (
    <ListItems>
      {planningItems.map(item => (
        <VolumeSectionWrapper
          key={item.id}
          sectionId={item.id}
          sectionHeader={item.header}
          materials={item.materials}
          showContents={showContents === item.id}
          setShowContents={toggleMaterials}
        />
      ))}
    </ListItems>
  );
};
